module.exports = __webpack_public_path__ + "r-v3/img/x.a3ec521c.svg";